import {
  EMemberCenterErrorCode,
  RESEND_VERIFICATION_CODE_COOLDOWN_MS,
} from 'constants/memberCenter';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import axios from 'plugins/api/axios';
import { useLoadingService } from 'services/LoadingService';
import { PATH } from 'routes/routeConfig';
import { t } from 'utils/i18n';
import { Dialog } from 'components/Dialog';
import VerificationCodeForm from 'components/VerificationCodeForm';

const { memberCenter } = axios;

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);
  const { showLoading, hideLoading } = useLoadingService();

  const account = searchParams.get('account') ?? '';
  const email = searchParams.get('email') ?? '';
  const resendAvailableAt = Number(searchParams.get('resendAvailableAt')) || 0;
  const source = searchParams.get('source') ?? 'register';
  const isFromLogin = source === 'login';

  const handleSubmit = async (code: string) => {
    showLoading();
    const response = await memberCenter.verifyDevice({ account, code });
    hideLoading();
    if (
      response.err === EMemberCenterErrorCode.SUCCESS &&
      response.data?.isValid
    ) {
      setIsVerified(true);
      return 'success';
    }
    if (response.err === EMemberCenterErrorCode.VERIFICATION_CODE_EXPIRED) {
      return 'expired';
    }
    if (response.err === EMemberCenterErrorCode.VERIFICATION_CODE_LOCKED) {
      return 'locked';
    }
    return 'invalid';
  };

  const handleResend = async () => {
    showLoading();
    const response = await memberCenter.resendVerifyDevice({
      account,
      project: 'OneTeacher',
    });
    hideLoading();
    if (response.err === EMemberCenterErrorCode.SUCCESS) {
      const params = new URLSearchParams({
        account,
        email,
        resendAvailableAt: String(
          Date.now() + RESEND_VERIFICATION_CODE_COOLDOWN_MS,
        ),
        source,
      });
      navigate(`${PATH.VERIFY_EMAIL}?${params.toString()}`, {
        replace: true,
      });
      return true;
    }
    return false;
  };

  return (
    <>
      <VerificationCodeForm
        title={
          isFromLogin
            ? t('login.unverifiedAccount.verifyEmailTitle', '完成帳號驗證')
            : t('register.emailVerification.teacherRegister', '註冊帳號')
        }
        description={t(
          'register.emailVerification.emailVerificationSent',
          '我們已寄送一組驗證碼至 {{email}}，請輸入驗證碼完成信箱驗證。',
          { email },
        )}
        resendAvailableAt={resendAvailableAt}
        onBack={() => navigate(isFromLogin ? PATH.LOGIN : PATH.REGISTER)}
        onSubmit={handleSubmit}
        onResend={handleResend}
      />
      <Dialog
        open={isVerified}
        title={
          isFromLogin
            ? t('login.unverifiedAccount.verifySuccessTitle', '驗證成功')
            : t('register.emailVerification.successTitle', '帳號註冊成功')
        }
        close={{ show: false, action: () => {} }}
        confirm={{
          text: t('register.emailVerification.goToLogin', '確認'),
          show: true,
          action: () => navigate(PATH.LOGIN, { replace: true }),
        }}
      >
        {t(
          'register.emailVerification.successHint',
          '信箱驗證完成，請回到首頁重新登入。',
        )}
      </Dialog>
    </>
  );
};

export default VerifyEmail;
